export const QueryParam = {
  Organization: 'institute',
  ReturnUrl: 'returnUrl',
  Form: 'form',
  AccessProgram: 'access-programs',
  PhysicianId: 'patient-access-form'
}
